import { Button } from "~/components/ui/button";
import { HOME_PAGE_SECTION_IDS, locations } from "./constants";
import LocationCard from "../Card/LocationCard";
import Container from "~/components/atoms/Container";

export const PopularLocations = ({ places, region }: { places: any }) => {
  // Check if places is the new object structure with results array or legacy array
  const placesList = places?.results || places;

  // Safety check for places data
  if (!placesList || !Array.isArray(placesList) || placesList.length === 0) {
    return (
      <Container htmlFor="ultra-wide">
        <div id={HOME_PAGE_SECTION_IDS.popularLocations} className="relative py-4 bg-gray-50 w-full bg-center bg-cover scroll-mt-28">
          <div className='relative mx-auto'>
            <p className="text-base text-center font-semibold text-gray-500 uppercase tracking-wide mb-2">
              LOCATIONS
            </p>
            <h2 className="text-3xl text-center md:text-3xl font-bold text-gray-700 mb-10">
              Popular Office Locations Near You
            </h2>
            <div className="text-center text-gray-500">
              No locations available at the moment.
            </div>
          </div>
        </div>
      </Container>
    );
  }

  // Map the new data structure to what LocationCard expects
  const mappedPlaces = placesList.map((place: any, index: number) => {
    const rawCities = place.areas
      ? place.areas.map((area: any) => ({
        ...area,
        city: area.suburb || area.city,
      }))
      : place.cities || [];

    const totalCitiesCount = rawCities.length;

    // target indices 1, 2, 4, and 5
    const targetIndices = [1, 2, 4, 5];

    const citiesToPass = targetIndices.includes(index)
      ? rawCities.slice(0, 5)
      : rawCities;

    return {
      id: place.cityId || place.id,
      state: place.city || place.state,
      stateimage: place.cityImage || place.stateimage,
      cities: citiesToPass,
      totalCitiesCount: totalCitiesCount,
    };
  });

  // Limit to 6 places max to reduce DOM size
  const displayPlaces = mappedPlaces;
  return (
    <Container htmlFor="ultra-wide">
      <div id={HOME_PAGE_SECTION_IDS.popularLocations} className="relative py-4 bg-gray-50 w-full bg-center bg-cover scroll-mt-28">
        <div className='relative mx-auto'>
          <p className="text-base text-center font-semibold text-gray-500 uppercase tracking-wide mb-2">
            LOCATIONS
          </p>
          <h2 className="text-3xl text-center md:text-3xl font-bold text-gray-700 mb-10">
            Popular Office Locations Near You
          </h2>

          <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2 px-4 place-items-center'>
            {/* First Column - Full Height Card */}
            {displayPlaces[0] && <LocationCard location={displayPlaces[0]} region={region} className='h-[250px] md:h-[530px] w-full' />}
            {/* Second Column - Two Half Height Cards */}
            <div className='flex flex-col gap-2 w-full'>
              {displayPlaces[1] && <LocationCard
                region={region}
                location={displayPlaces[1]}
                className='h-[121px] md:h-[261px] w-full'
              />}
              {displayPlaces[2] && <LocationCard
                region={region}
                location={displayPlaces[2]}
                className='h-[121px] md:h-[261px] w-full'
              />}
            </div>
            {displayPlaces[3] && <LocationCard location={displayPlaces[3]} region={region} className='hidden md:block h-[530px] w-full' />}
            <div className='flex-col gap-2 w-full hidden md:flex'>
              {displayPlaces[4] && <LocationCard
                region={region}
                location={displayPlaces[4]}
                className='h-[261px] w-full'
              />}
              {displayPlaces[5] && <LocationCard
                region={region}
                location={displayPlaces[5]}
                className='h-[261px] w-full'
              />}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
